module.exports = __webpack_public_path__ + "img/img_null.79057873.png";